import React, { Dispatch, SetStateAction, useState } from "react";
import FilterChipDisplay from "../../../Filtering/FilterChipDisplay";
import DateFilterDialog from "../CustomFilters/DateFilterDialog";
import InsightFiltersViewModel from "../../ViewModels/InsightFiltersViewModel";
import { InsightView } from "../../../ViewModels/InsightView";
import { formatDate } from "../../../Utilities/UtilityMethods";

interface IDateFilterContainerProps {
    view: InsightView
    filters: InsightFiltersViewModel
    setFilters: Dispatch<SetStateAction<InsightFiltersViewModel>>
}

export default function DateFilterContainer({ view, filters, setFilters }: IDateFilterContainerProps) {
    const [isDialogOpen, setIsDialogOpen] = useState(false);

    let preset = filters.datePreset;
    switch (preset) {
        case "Custom Day":
            preset = formatDate(filters.startDate);
            break;
        case "Custom Week":
        case "Custom Month":
            preset = formatDate(filters.startDate) + " - " + formatDate(filters.endDate);
            break;
    }
    const text = `Date: ${preset}`;

    return (
        <>
            <FilterChipDisplay
                text={text}
                selectable
                onClick={() => setIsDialogOpen(true)} />
            <DateFilterDialog
                view={view}
                open={isDialogOpen}
                setOpen={setIsDialogOpen}
                filters={filters}
                setFilters={setFilters} />
        </>
    );
}
